import { Effect } from "../../Materials/effect";
var name = 'bumpVertex';
var shader = "#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)\n#if defined(TANGENT) && defined(NORMAL)\nvec3 tbnNormal=normalize(normalUpdated);\nvec3 tbnTangent=normalize(tangentUpdated.xyz);\nvec3 tbnBitangent=cross(tbnNormal,tbnTangent)*tangentUpdated.w;\nvTBN=mat3(finalWorld)*mat3(tbnTangent,tbnBitangent,tbnNormal);\n#endif\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var bumpVertex = { name: name, shader: shader };
//# sourceMappingURL=bumpVertex.js.map